import { call, put } from 'redux-saga/effects'
import {
  setLoading,
  setError,
  setPromoEventList,
  setSuccess,
  setNewPromoEvent,
  setProcessing,
  setEventDoctorAssociationInfo,
  setAssociatedDoctorToEvent
} from '../../slices/promoEventSlice'
import {
  requestPromoEventCreation,
  requestPromoEventsList,
  requestToggleEventStatus,
  requestEventDoctorAssociation,
  requestDoctorsAssociation
} from '../requests/promoEventService'
import { toast } from 'react-toastify'

function* handleFetchPromoEvents() {
  try {
    yield put(setLoading())
    const response = yield call(() => requestPromoEventsList())
    yield put(setPromoEventList(response.data))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    yield put(setError(errMsg))
  }
}

function* handleTogglePromoEventStatus(action) {
  const { eventId, togglePayload } = action.payload
  try {
    yield put(setProcessing())
    yield call(() => requestToggleEventStatus(eventId, togglePayload))
    yield put(setSuccess())
    toast.info('Action completed successfully!')
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

function* handleCreatePromoEvent(action) {
  const { event } = action.payload
  try {
    yield put(setProcessing())
    const response = yield call(() => requestPromoEventCreation(event))
    yield put(setNewPromoEvent(response.data))
    toast.success('Event created successfully!')
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

function* handleFetchEventDoctorAssociation(action) {
  try {
    yield put(setLoading())
    const response = yield call(() => requestEventDoctorAssociation(action.payload))
    yield put(setEventDoctorAssociationInfo(response.data))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } 
}

function* handleEventDoctorAssociation(action){
  try{
    yield put(setProcessing())
    const {eventId, payload} = action.payload ;
    yield call(() => requestDoctorsAssociation(eventId, payload))
    yield put(setAssociatedDoctorToEvent(action.payload));
  }catch(error){
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  }finally{
    yield put(setProcessing(false))
  }
}


export {
  handleFetchPromoEvents,
  handleTogglePromoEventStatus,
  handleCreatePromoEvent,
  handleFetchEventDoctorAssociation,
  handleEventDoctorAssociation
}
